export default {"src":"__ASTRO_ASSET_IMAGE__BXog2n08__","width":61,"height":62,"format":"svg"}